import React, { useState } from "react";

const DepositModal = ({
    open,
    onClose,
    selectedOrder,
    onSubmit,
    isDark,
}) => {

    const [notes, setNotes] = useState("");

    if (!open) return null;

    const colors = {
        bg: isDark ? "#111827" : "#ffffff",
        border: isDark ? "#374151" : "#e5e7eb",
        text: isDark ? "#ffffff" : "#111827",
        light: isDark ? "#9ca3af" : "#6b7280",
    };

    return (

        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.55)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
            }}
        >

            <div
                style={{
                    width: 420,
                    background: colors.bg,
                    borderRadius: 16,
                    padding: 24,
                }}
            >

                <h2
                    style={{
                        marginTop: 0,
                        color: colors.text,
                    }}
                >
                    Collect Cash
                </h2>

                <div
    style={{
        marginBottom: 20,
        color: colors.light,
    }}
>
    <b>Selected Orders</b>

    <div style={{ marginTop: 10 }}>
        {selectedOrder?.map((item) => (
            <div key={item.id}>
                #{item.id} - ₹{item.final_amount}
            </div>
        ))}
    </div>
</div>

                <div
                    style={{
                        marginBottom: 20,
                    }}
                >

                    <label>

                        Cash Amount

                    </label>

                    <input
    readOnly
    value={
        selectedOrder
            ?.reduce(
                (sum, item) =>
                    sum + Number(item.final_amount || 0),
                0
            )
            .toFixed(2) || ""
    }
                        style={{
                            width: "100%",
                            marginTop: 8,
                            padding: 10,
                            borderRadius: 8,
                            border: `1px solid ${colors.border}`,
                        }}
                    />

                </div>

                <div>

                    <label>

                        Notes

                    </label>

                    <textarea

                        rows={4}

                        value={notes}

                        onChange={(e) => setNotes(e.target.value)}

                        style={{
                            width: "100%",
                            marginTop: 8,
                            padding: 10,
                            borderRadius: 8,
                            border: `1px solid ${colors.border}`,
                        }}

                    />

                </div>

                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: 25,
                        gap: 10,
                    }}
                >

                    <button
                        onClick={onClose}
                    >
                        Cancel
                    </button>

                    <button

                        style={{
                            background: "#16a34a",
                            color: "#fff",
                            border: "none",
                            padding: "10px 18px",
                            borderRadius: 8,
                            cursor: "pointer",
                        }}

                        onClick={() => {

                           onSubmit({

    orders: selectedOrder,

    notes,

});
                        }}

                    >

                        Submit

                    </button>

                </div>

            </div>

        </div>

    );

};

export default DepositModal;